// osifont: ISO 3098 technical lettering, the draughtsman's hand used in CAD
// title blocks. LGPL-3.0 with the GPL font exception (see LICENSE.txt);
// shipped unmodified, added by this fork.
import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Osifont from "./Osifont-Regular.woff2";

export const OsifontFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: Osifont,
  },
];
